import * as Yup from "yup";

export default Yup.object().shape({
  issueType: Yup.string().required("Reason for marking Inactive is required"),
  issueDetails: Yup.string()
    .nullable()
    .max(500, "Comments cannot exceed 500 characters")
    .required("Comments are required"),
});
